import React from 'react'

interface IQuestionList {
    number: number;
    text?: string;
    children?: React.ReactNode
}

const QuestionList: React.FC<IQuestionList> = ({ number, text, children }) => {
    return (
        <div className='w-full flex items-start justify-start'>
            <div className='min-w-[28px] h-[28px] rounded-full flex items-center justify-center bg-brand-accent text-white text-[13px] font-extrabold mr-3'>
                {number}
            </div>
            <div className='w-full pt-[3px]'>
                {text && <h2 className='text-titleSM text-white'>{text}</h2>}
                {children}
            </div>
        </div>
    )
}

export default QuestionList
